module.exports = __webpack_public_path__ + "img/dovs_dovvaultfort.245fe41.png";